(function () {
    var ANIMATION_DURATION = 300;

    function triggerChange(el) {
        if (!el) return;
        var evt;
        try {
            evt = new Event('change', { bubbles: true });
        } catch (e) {
            evt = document.createEvent('Event');
            evt.initEvent('change', true, true);
        }
        el.dispatchEvent(evt);
    }

    function parseMoney(text) {
        if (!text) return null;
        var num = text.replace(/[^\d,]/g, '').replace(',', '.');
        var val = parseFloat(num);
        return isNaN(val) ? null : val;
    }

    function formatMoney(val, template) {
        if (val === null || !template) return '';
        var currency = template.replace(/[\d\s,\.]/g, '');
        return currency + val.toFixed(2).replace('.', ',');
    }

    function findRoot(el) {
        var root = el;
        for (var i = 0; i < 15; i++) {
            if (!root || root === document) break;
            if (
                root.classList &&
                (root.classList.contains('product__info-container') ||
                    root.classList.contains('product__info-wrapper'))
            ) {
                return root;
            }
            root = root.parentNode;
        }
        return null;
    }

    document.addEventListener('DOMContentLoaded', function () {
        var rows = document.querySelectorAll('.quantity-tabs__row');
        if (!rows.length) return;

        for (var r = 0; r < rows.length; r++) {
            (function (row) {
                var tabs = row.querySelectorAll('.quantity-tabs__item');
                if (!tabs.length) return;

                var root = findRoot(row);
                if (!root) return;

                var manualQuantity = root.querySelector('.product__quantity');
                var manualInput = manualQuantity
                    ? manualQuantity.querySelector('.quantity__input')
                    : null;

                if (!manualQuantity || !manualInput) return;

                var saleEl = root.querySelector('.price-item--sale[data-money]');
                var regularEl = root.querySelector('.price-item--regular[data-money]');
                var unitEl = root.querySelector('.unit-price span[data-info-variant]');

                function resetPrices() {
                    if (saleEl) saleEl.textContent = saleEl.getAttribute('data-money');
                    if (regularEl) regularEl.textContent = regularEl.getAttribute('data-money');
                    if (unitEl) unitEl.textContent = unitEl.getAttribute('data-info-variant');
                }

                function updatePricesByQty(qty) {
                    var q = parseInt(qty, 10);
                    if (!q || q <= 1) {
                        resetPrices();
                        return;
                    }

                    // беремо БАЗОВУ ціну ТІЛЬКИ з data-money
                    var baseMoneyText = null;

                    if (saleEl && saleEl.getAttribute('data-money')) {
                        baseMoneyText = saleEl.getAttribute('data-money'); // "€16,80"
                    } else if (regularEl && regularEl.getAttribute('data-money')) {
                        baseMoneyText = regularEl.getAttribute('data-money');
                    }

                    if (!baseMoneyText) return;

                    // --- основна ціна (сума) ---
                    var baseValue = parseMoney(baseMoneyText); // 16.8
                    var totalText = formatMoney(baseValue * q, baseMoneyText);

                    if (saleEl) saleEl.textContent = totalText;
                    if (regularEl) regularEl.textContent = totalText;

                    // --- unit price: РІВНО "€16,80 × 3" ---
                    if (unitEl) {
                        unitEl.textContent = baseMoneyText + ' × ' + q;
                    }
                }

                function showManualQuantity() {
                    manualQuantity.classList.remove('is-collapsed');
                    manualQuantity.style.height = manualQuantity.scrollHeight + 'px';

                    setTimeout(function () {
                        manualQuantity.style.height = '';
                    }, ANIMATION_DURATION);

                    setTimeout(function () {
                        manualInput.value = 1;
                        triggerChange(manualInput);
                        resetPrices();
                    }, ANIMATION_DURATION);
                }

                function hideManualQuantityAndSetQty(qty) {
                    manualQuantity.style.height = manualQuantity.scrollHeight + 'px';

                    window.requestAnimationFrame(function () {
                        manualQuantity.classList.add('is-collapsed');
                        manualQuantity.style.height = '0px';
                    });

                    setTimeout(function () {
                        manualInput.value = qty;
                        triggerChange(manualInput);
                        updatePricesByQty(qty);
                    }, ANIMATION_DURATION);
                }

                function setActiveTab(active) {
                    for (var i = 0; i < tabs.length; i++) {
                        tabs[i].classList.remove('is-active');
                    }
                    active.classList.add('is-active');
                }

                for (var i = 0; i < tabs.length; i++) {
                    tabs[i].addEventListener('click', function () {
                        var qty = this.getAttribute('data-qty');
                        setActiveTab(this);

                        if (qty === 'any') {
                            showManualQuantity();
                        } else {
                            hideManualQuantityAndSetQty(qty);
                        }
                    });
                }

                /* initial sync */
                var active = row.querySelector('.quantity-tabs__item.is-active');
                if (active) {
                    var initQty = active.getAttribute('data-qty');
                    if (initQty && initQty !== 'any') {
                        manualQuantity.classList.add('is-collapsed');
                        manualQuantity.style.height = '0px';
                        manualInput.value = initQty;
                        triggerChange(manualInput);
                        updatePricesByQty(initQty);
                    } else {
                        manualInput.value = 1;
                        triggerChange(manualInput);
                        resetPrices();
                    }
                }
            })(rows[r]);
        }
    });
})();
